<!--  -->
<template>
 <cc-container>
      <cc-main  >
         <div class="skeketon">
      <cc-header-nav style="height:106px">
     <div slot="left" class="information">
       <div class="head_sculpture">
         <span></span>
        </div>
       <div class="user_information">
       <span class="name"></span>
       </div>
     </div>
     <div slot="right" class="code" v-if="+role==3">
       <div class="code-box"></div>
     </div>
      </cc-header-nav>

          <div class="skeketon-block" style="margin-top:-30px" v-if="+role!==3">
            <ul class="skeketon-ul" >
              <li class="skeketon-item" v-for="i in 4" :key="i">
                <div class="skeketon-icon"></div>
              </li>
            </ul>
          </div>
          <div class="skeketon-block" style="margin-top:-30px;padding:20px 0" v-if="role=='3'">
            <div class="skeketon-msg"></div>
          </div>
          <div class="skeketon-block" v-if="+role!==3">
            <div class="subhead"></div>
            <ul class="skeketon-ul" >
              <li class="skeketon-item" v-for="i in 4" :key="i">
                <div class="skeketon-icon skeketon-icon2"></div>
              </li>
            </ul>
          </div>
           <div class="skeketon-block" v-if="+role==3">
            <div class="subhead"></div>
            <ul class="skeketon-ul" >
              <li class="skeketon-item" v-for="i in 5" :key="i">
              </li>
            </ul>
          </div>
           <div class="skeketon-block" v-if="+role!==3">
            <div class="subhead"></div>
            <ul class="skeketon-ul" >
              <li class="skeketon-item" v-for="i in 3" :key="i">
                <div class="skeketon-icon skeketon-icon2"></div>
              </li>
            </ul>
          </div>
              <div class="skeketon-block" v-if="+role==3">
            <div class="subhead"></div>
            <ul class="skeketon-ul" >
              <li class="skeketon-item" v-for="i in 2" :key="i">
                <div class="skeketon-icon skeketon-icon2"></div>
              </li>
            </ul>
          </div>
           <div class="skeketon-block" v-if="+role==3">
            <div class="subhead"></div>
            <ul class="skeketon-ul" >
              <li class="skeketon-item" v-for="i in 5" :key="i">
                <div class="skeketon-icon skeketon-icon2"></div>
              </li>
            </ul>
          </div>
           <div class="skeketon-block" v-if="+role!==3">
            <div class="subhead"></div>
            <ul class="skeketon-ul skeketon-ul2" >
              <li class="skeketon-item " v-for="i in 8" :key="i" style="width:80px; height:60px;background:#fff;">
                <div class="skeketon-icon skeketon-icon2"></div>
              </li>
            </ul>
          </div>
      </div>
    </cc-main>
  </cc-container>
</template>

<script>
export default {
  data () {
    return {
      role: ''
    }
  },
  created () {
    if (window.sessionStorage.getItem('roleType')) {
      this.$set(this, 'role', window.sessionStorage.getItem('roleType'))
    }
  },
  activated () {
    setTimeout(async () => {
      let role = await this.getLoginStatus && this.getLoginStatus.data.role
      if (role) {
        window.sessionStorage.setItem('roleType', role)
      }
    })
    this.$nextTick(() => {
      this.$set(this, 'role', window.sessionStorage.getItem('roleType'))
    })
  }
}
</script>
<style lang='scss' scoped>
.skeketon{
  @include skeletonBlink();
  &-block{
    width: 355px;
     background: var(--APP_skeleton_background_color);
    border-radius: 10px;
    padding: 10px 0;
    margin: 0 auto;
    margin-bottom: 10px;
  }
  .subhead{
    width: 58px;
    height: 14px;
    background: var(--APP_skeleton_color);
    border-radius: 3px;
    margin-bottom: 25px;
    margin-left: 10px;
  }
  &-msg{
    margin-left: 20px;
    width: 300px;
    height: 25px;
    border-radius: 3px;
    background: var(--APP_skeleton_color);
  }
  &-ul{
   display: flex;
   flex-direction: row;
   justify-content:space-around;
   width: 100%;
   height: 100%;
  }
  &-ul2{
    flex-wrap: wrap;

  }
  &-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 39px;
    height: 39px;
    background: var(--APP_skeleton_color);
    border-radius: 3px;
  }

   &-icon{
       width: 18px;
       height: 18px;
      background: var(--APP_skeleton_color);
       margin-bottom: 10px;
       border-radius: 3px;
    }
    &-icon2{
       width: 39px;
       height: 39px;
       margin-bottom: 20px;
    }
    &-title{
      width: 48px;
      height: 12px;
      background: var(--APP_skeleton_color);
       border-radius: 3px;
    }

}
.information{
  display: flex;
  flex-direction: row;
  align-items: center;
}
  .head_sculpture{
    >span{
      display: inline-block;
       width: 43px;
      height: 43px;
      border-radius: 50%;
      margin: 0 10px 0 20px;
      background-color: #fff;
      opacity: .5;
    }

  }
  .user_information{
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
    .name{
     width: 124px;
     height: 25px;
      background-color: #fff;
      opacity: .5;
      border-radius: 3px;

    }
    .tel{
      width: 80px;
      height: 10px;
      background-color: var(--APP_theme_color_colorOpacity5);
      border-radius: 3px;
      margin-top: 10px;
    }
  }
  .role{
    width: 57px;
    height: 17px;
    background-color:var(--APP_theme_color_colorOpacity5);
    border-radius: 3px;
    margin-bottom: 35px;
  }
  .code{
    margin-top: -10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 10px;
    &-box{
      width: 30px;
      height: 30px;
      border-radius: 3px;
      background-color: var(--APP_theme_color_colorOpacity5);
      margin-bottom: 5px;
    }
    &-tip{
      width: 51px;
      height: 12px;
       border-radius: 3px;
      background-color: var(--APP_theme_color_colorOpacity5);
    }
  }
</style>
